import { render } from "./SetObjectOwners.vue?vue&type=template&id=1a63778a"
import script from "./SetObjectOwners.vue?vue&type=script&lang=js"
export * from "./SetObjectOwners.vue?vue&type=script&lang=js"

import "./SetObjectOwners.vue?vue&type=style&index=0&id=1a63778a&lang=css"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__